import { render, staticRenderFns } from "./WalletLogList.vue?vue&type=template&id=36412b8a&scoped=true"
import script from "./WalletLogList.vue?vue&type=script&lang=js"
export * from "./WalletLogList.vue?vue&type=script&lang=js"
import style0 from "./WalletLogList.vue?vue&type=style&index=0&id=36412b8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36412b8a",
  null
  
)

export default component.exports